module.exports = __webpack_public_path__ + "img/GS_Profile-Tumelo Chewe.d980dc14.png";